// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__1qYbH","LoaderContent":"Loader_LoaderContent__c9NH1","Bar":"Loader_Bar__1lWE9","BarFill":"Loader_BarFill__24IY6","Persent":"Loader_Persent___zpux"};